import { render, staticRenderFns } from "./ViewForm.vue?vue&type=template&id=4bb2b320&scoped=true"
import script from "./ViewForm.vue?vue&type=script&lang=js"
export * from "./ViewForm.vue?vue&type=script&lang=js"
import style0 from "./ViewForm.vue?vue&type=style&index=0&id=4bb2b320&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb2b320",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4bb2b320')) {
      api.createRecord('4bb2b320', component.options)
    } else {
      api.reload('4bb2b320', component.options)
    }
    module.hot.accept("./ViewForm.vue?vue&type=template&id=4bb2b320&scoped=true", function () {
      api.rerender('4bb2b320', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Operation/OperationWorkOrder/ViewForm.vue"
export default component.exports